/**
 * @file 漏洞信息查询
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {fetchVulHomepagee, fetchVulSearch, fetchVulDetail} from '../../actions/bugSearchAction';

import './index.less';

class BugSearch extends Component {
    static propTypes = {
        history: PropTypes.object,
        fetchVulDetail: PropTypes.func,
        fetchVulSearch: PropTypes.func,
        fetchVulHomepagee: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        let vulName = this.getRequest().vul_name;
        let vulNum = this.getRequest().vul_num;
        let appName = this.getRequest().app_name;
        let vulLevel = this.getRequest().vul_level;
        let id = this.getRequest().id;
        let from = this.getRequest().from;
        this.state = {
            id: id || '',
            from: from || '',
            bugTitle: vulName ? decodeURI(vulName) : '',
            bugIndex: vulNum ? decodeURI(vulNum) : '',
            appName: appName ? decodeURI(appName) : '',
            levelId: vulLevel || 'all',
            newData: [],
            hotData: [],
            infoObj: {},
            page: 1,
            count: 10,
            searchMore: vulNum || appName || vulLevel || false,
            searchData: [],
            infoOff: false,
            searchOff: false
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = `/bug_search${location.search}`;
        }
    }

    componentDidMount() {
        let vulName = this.getRequest().vul_name;
        let vulNum = this.getRequest().vul_num;
        let appName = this.getRequest().app_name;
        let vulLevel = this.getRequest().vul_level;
        let id = this.getRequest().id;
        let from = this.getRequest().from;

        if (id && from === 'alading') {
            this.props.fetchVulDetail({id: id}).then(res => {
                let data = res.data;
                if (data.status === 0) {
                    this.infoFn(data.data);
                    window.scrollTo(0, this.more.offsetTop - this.more.offsetHeight);
                }
            });
            return;
        }

        if (vulName || vulNum || appName || vulLevel) {
            this.getSerachFn();
        } else {
            this.props.fetchVulHomepagee().then(res => {
                let data = res.data;
                if (res.data.status === 0) {
                    this.setState({
                        newData: data.data.last_vul_list,
                        hotData: data.data.hot_vul_list
                    });
                }
            });
        }
    }

    getSerachFn = off => {
        let {bugTitle, searchData, bugIndex, appName, page, levelId, moreObj, searchMore} = this.state;
        let json = {
            page: page,
            perPage: 10
        };
        let urlData = [];

        if (off) {
            json = moreObj;
            json.page = page;
        } else {
            if (bugTitle) {
                json['vul_name'] = bugTitle;
            }

            if (searchMore) {
                if (bugIndex) {
                    json['vul_num'] = bugIndex;
                }
                if (appName) {
                    json['app_name'] = appName;
                }
                if (levelId !== 'all') {
                    json['vul_level'] = levelId;
                }
            }
        }

        for (let attr in json) {
            if (attr !== 'page' && attr !== 'perPage') {
                urlData.push(attr + '=' + json[attr]);
            }
        }

        this.props.history.push(`/bug_search?${urlData.join('&')}`);

        this.props.fetchVulSearch(json).then(res => {
            let data = res.data;
            if (res.data.status === 0) {
                this.setState({
                    moreObj: json,
                    count: data.data.count,
                    searchOff: true,
                    infoOff: false,
                    searchData: page === 1 ? data.data.rows : [...searchData, ...data.data.rows]
                });

            }
        });
    };

    infoFn = item => {
        this.setState({
            infoOff: true,
            infoObj: item
        });
    };

    render() {
        let {
            count, page, bugTitle, bugIndex, appName, newData, infoOff, levelId, hotData, searchMore, searchOff,
            searchData, infoObj
        } = this.state;
        let levelData = [
            {id: 'all', name: '全部'},
            {id: '3', name: '高'},
            {id: '2', name: '中'},
            {id: '1', name: '低'}
        ];
        let showOff = false;

        if (Math.ceil(count / 10) <= page) {
            showOff = true;
        }

        return (
            <div className={'bug_search'}>
                <h2>
                    漏洞信息查询
                </h2>

                <div className={'mod1'}>
                    <div className={'item'}>
                        <div className={'title'}>漏洞标题：</div>
                        <div className={'text inputS'}>
                            <input
                                type="text"
                                defaultValue={bugTitle}
                                placeholder={'请输入关键字'}
                                onChange={event => {
                                    this.setState({
                                        bugTitle: event.target.value
                                    });
                                }}
                            />
                        </div>
                    </div>
                    {
                        searchMore
                            ? <div>
                                <div className={'item'}>
                                    <div className={'title'}>漏洞编号：</div>
                                    <div className={'text inputS'}>
                                        <input
                                            type="text"
                                            defaultValue={bugIndex}
                                            placeholder={'CVE/CNVD/CNNVD'}
                                            onChange={event => {
                                                this.setState({
                                                    bugIndex: event.target.value
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={'item'}>
                                    <div className={'title'}>应用名称：</div>
                                    <div className={'text inputS'}>
                                        <input
                                            type="text"
                                            defaultValue={appName}
                                            placeholder={'请输入关键字'}
                                            onChange={event => {
                                                this.setState({
                                                    appName: event.target.value
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={'item'}>
                                    <div className={'title'}>漏洞等级：</div>
                                    <div className={'text'}>
                                        {
                                            levelData.map(item => {
                                                return <div
                                                    className={levelId === item.id ? 'tab on' : 'tab'}
                                                    key={item.id}
                                                    onClick={() => {
                                                        this.setState({
                                                            levelId: item.id
                                                        });
                                                    }}
                                                >
                                                    {item.name}
                                                </div>;
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            : null
                    }


                </div>

                <div
                    className={'m-btn'}
                    onClick={() => {
                        this.setState({
                            page: 1,
                            count: 10,
                        }, () => {
                            this.getSerachFn();
                        });
                    }}
                >
                    搜索
                </div>

                <div
                    className={'more'}
                    ref={el => this.more = el}
                    onClick={() => {
                        this.setState({
                            searchMore: !searchMore
                        });
                    }}
                >
                    {
                        searchMore
                            ? '恢复默认搜索'
                            : '高级搜索'
                    }

                </div>

                {!infoOff
                    ? !searchOff
                        ? <div className={'mod2'}>
                            <div>
                                <div className={'title'}>最新漏洞</div>
                                <div className={'text'}>
                                    {
                                        newData.map((item, index) => {
                                            return <div
                                                key={index}
                                                onClick={() => {
                                                    this.infoFn(item);
                                                }}
                                            >
                                                {item.vul_name}
                                            </div>;
                                        })
                                    }
                                </div>
                            </div>
                            <div>
                                <div className={'title'}>最热漏洞</div>
                                <div className={'text'}>
                                    {
                                        hotData.map((item, index) => {
                                            return <div
                                                key={index}
                                                onClick={() => {
                                                    this.infoFn(item);
                                                }}
                                            >
                                                {item.vul_name}
                                            </div>;
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        : <div className={'res-mod'}>
                            <div className={'title'}>搜索结果</div>
                            {
                                searchData.length
                                    ? <div className={'list'}>
                                        {searchData.map((item, index) => {
                                            return <div
                                                key={index}
                                                dangerouslySetInnerHTML={{__html: item.vul_name}}
                                                onClick={() => {
                                                    this.infoFn(item);
                                                }}
                                            />;
                                        })}
                                        {
                                            count > 10
                                                ? <span
                                                    className={'load-more'}
                                                    onClick={() => {
                                                        let val = 1;
                                                        if (!showOff) {
                                                            val = page + 1;
                                                        }
                                                        this.setState({
                                                            page: val
                                                        }, () => {
                                                            this.getSerachFn(true);
                                                        });
                                                    }}
                                                >
                                                    {showOff ? '收起' : '加载更多'}
                                                </span>
                                                : null
                                        }

                                    </div>
                                    : <div className={'text'}>
                                        没找到符合条件的结果
                                    </div>
                            }
                        </div>
                    : <div className={'info-mod'}>
                        <div className={'title'}>漏洞标题</div>
                        <div
                            className={'text'}
                            dangerouslySetInnerHTML={{__html: infoObj.vul_name || '-'}}
                        />

                        <div className={'title'}>漏洞等级</div>
                        <div className={'text'}>
                            {
                                {
                                    '1': '低',
                                    '2': '中',
                                    '3': '高'
                                }[infoObj.vul_level] || '-'
                            }
                        </div>

                        <div className={'title'}>CNVD漏洞编号</div>
                        <div className={'text'} dangerouslySetInnerHTML={{__html: infoObj.cnvd || '-'}}/>

                        <div className={'title'}>CNNVD漏洞编号</div>
                        <div className={'text'} dangerouslySetInnerHTML={{__html: infoObj.cnnvd || '-'}}/>

                        <div className={'title'}>CVE漏洞编号</div>
                        <div className={'text'} dangerouslySetInnerHTML={{__html: infoObj.cve || '-'}}/>

                        <div className={'title'}>应用名称</div>
                        <div className={'text'} dangerouslySetInnerHTML={{__html: infoObj.app_name || '-'}}/>

                        <div className={'title'}>影响版本</div>
                        <div className={'text'}>{infoObj.app_version_content || '-'}</div>

                        <div className={'title'}>漏洞介绍</div>
                        <div className={'text'}>
                            {infoObj.vul_summary || '-'}
                        </div>

                        <div className={'title'}>修复建议</div>
                        <div className={'text'}>{infoObj.vul_solution || '-'}</div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        userApplyData: state.userApplyData,
        cmsapiUserapply: state.cmsapiUserapply
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchVulDetail: obj => fetchVulDetail(dispatch, obj),
        fetchVulSearch: obj => fetchVulSearch(dispatch, obj),
        fetchVulHomepagee: () => fetchVulHomepagee(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BugSearch));



// WEBPACK FOOTER //
// ./src/containers/bugSearch/index.js